import { CaseApiModel, QuoteApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { onlyUnique } from './ArrayHelper';
import { GetExternalTrackingNumber } from './SmartSendSummaryGenerator';

export function QuoteCsvExportHeaders(): string[] {
  return ['Courier', 'Service', 'Type'];
}

export function MapQuoteToCsv(i: QuoteApiModel): string[] {
  return [i.Service.CourierName, i.Service.Name, `${i.Service.CollectionType} > ${i.Service.DeliveryType}`];
}

export function ClaimCsvExportHeaders(): string[] {
  return ['Id', 'Reference', 'Status', 'LastUpdated', 'Customer'];
}

export function MapClaimToCsv(i: CaseApiModel): string[] {
  return [i.Id as any, i.ReferenceNumber || `P2G${i.InternalId}`, i.Status.Name, i.LastUpdated, i.CustomerName];
}

export function ProblemParcelCsvExportHeaders(): string[] {
  return ['Id', 'Status'];
}

export function MapProblemParcelToCsv(i: CaseApiModel): string[] {
  return [i.Id as any, i.Status.Name];
}

export function MapSmartSendSoldItemToCsv(i: SmartSendItemApiModel): string[] {
  return [
    i.BookingDetails?.Reference,
    i.MarketplaceStatus,
    i.Created,
    i.Source?.Name,
    i.Recipient?.Name,
    i.Recipient?.Postcode,
    i.Recipient?.CountryIsoCode,
    i.MarketplaceOrderLines.map((x) => x.Product.Description)
      .filter((x) => !!x)
      .filter(onlyUnique)
      .join(',') || i.Description,
    i.Value as any,
    i.Service?.Name,
    i.MarketplaceOrderLines.map((x) => x.Product.Sku)
      .filter((x) => !!x)
      .filter(onlyUnique)
      .join(','),
    i.PackageDimensions?.Weight,
    i.PackageDimensions?.Length,
    i.PackageDimensions?.Width,
    i.PackageDimensions?.Height,
    i.Tags.join(','),
    i.MarketplaceOrderLines.map((x) => x.CustomerReference || x.MarketplaceOrderId)
      .filter((x) => !!x)
      .filter(onlyUnique)
      .join(',')
  ];
}

export function SmartSendCsvExportSoldHeaders(): string[] {
  return [
    'Reference',
    'MarketplaceStatus',
    'Created',
    'Source',
    'Customer',
    'Postcode',
    'Country',
    'Product',
    'Value',
    'Service',
    'Sku',
    'Weight',
    'Length',
    'Width',
    'Height',
    'Tags',
    'CustomerReference'
  ];
}

export function SmartSendCsvExportOrderHeaders(): string[] {
  return ['Reference', 'Created', 'Customer', 'Postcode', 'Country', 'Product', 'Value', 'Service', 'TrackingNumber'];
}

export function MapOrderToCsv(i: SmartSendItemApiModel): string[] {
  return [
    i.BookingDetails?.Reference,
    i.Created,
    i.Recipient?.Name,
    i.Recipient?.Postcode,
    i.Recipient?.CountryIsoCode,
    i.MarketplaceOrderLines.map((x) => x.Product.Description)
      .filter((x) => !!x)
      .filter(onlyUnique)
      .join(',') || i.Description,
    i.Value as any,
    i.Service?.Name,
    GetExternalTrackingNumber(i)
  ];
}

export function SmartSendCsvExportBookedHeaders(): string[] {
  return [
    'Reference',
    'MarketplaceStatus',
    'Created',
    'Source',
    'Customer',
    'Postcode',
    'Country',
    'Product',
    'Value',
    'Service',
    'Sku',
    'Weight',
    'Length',
    'Width',
    'Height',
    'Tags',
    'TrackingStatus',
    'TrackingNumber',
    'CustomerReference'
  ];
}

export function MapSmartSendBookedItemToCsv(i: SmartSendItemApiModel): string[] {
  return [
    i.BookingDetails?.Reference,
    i.MarketplaceStatus,
    i.Created,
    i.Source?.Name,
    i.Recipient?.Name,
    i.Recipient?.Postcode,
    i.Recipient?.CountryIsoCode,
    i.MarketplaceOrderLines.map((x) => x.Product.Description)
      .filter((x) => !!x)
      .filter(onlyUnique)
      .join(',') || i.Description,
    i.Value as any,
    i.Service?.Name,
    i.MarketplaceOrderLines.map((x) => x.Product.Sku)
      .filter((x) => !!x)
      .filter(onlyUnique)
      .join(','),
    i.PackageDimensions?.Weight,
    i.PackageDimensions?.Length,
    i.PackageDimensions?.Width,
    i.PackageDimensions?.Height,
    i.Tags.join(','),
    i.TrackingSummary?.LatestStatus,
    GetExternalTrackingNumber(i),
    i.MarketplaceOrderLines.map((x) => x.CustomerReference || x.MarketplaceOrderId)
      .filter((x) => !!x)
      .filter(onlyUnique)
      .join(',')
  ];
}
